// extracted by mini-css-extract-plugin
module.exports = {"game_conduction":"index-module_game_conduction_FKwKG","content":"index-module_content_3H29h","button":"index-module_button_16u6z"};